import request from '@/utils/request'

// 获取RSA公钥
export function getPublicKeyApi() {
    return request({
        url: `/auth/user/rsa/public-key`,
        method: 'get',
    })
}

// 获取图形验证码
export function getImgCodeApi() {
    return request({
        url: `/auth/user/getCode`,
        method: 'get',
    })
}

// 手机验证码
export function sendMobileCodeApi(data) {
    return request({
        url: `/auth/user/sendMobileCode`,
        method: 'post',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent
        },
    })
}

// 手机验证码v1
export function sendMobileCodeV1Api(data) {
    return request({
        url: `/auth/user/sendMobileCodeV1`,
        method: 'post',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent
        },
    })
}

// 登录
export function loginV4Api(data) {
    return request({
        url: `/auth/user/loginV4`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent,
            isToken:false,
        },
    })
}

// 登录V5
export function loginV5Api(data) {
    return request({
        url: `/auth/user/loginV5`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent,
            isToken:false,
        },
    })
}

// 注册
export function doRegisterApi(data) {
    return request({
        url: `/auth/user/doRegister`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent,
            isToken:false,
        },
    })
}

// 密码重置
export function resetPwdApi(data) {
    return request({
        url: `/auth/user/resetPwd`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent,
            isToken:false,
        },
    })
}

// 试听登录
export function loginV2BySMSForLiveApi(data) {
    return request({
        url: `/auth/user/loginV2BySMSForLive`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent,
            isToken:false
        },
    })
}


// 微信注册特定手机号 【新增：支持小程序，app 、pc；手机号绑定特定unionid /appid】
export function loginV2BySMSV2Api(data) {
    return request({
        url: `/auth/user/loginV2BySMSV2`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent,
            isToken:false
        },
    })
}

//微信登录接口
export function weChatLoginApi(data) {
    return request({
        url: `/auth/user/wechat/login`,
        method: 'POST',
        data,
        headers: {
            'device-type': '1',
            'device-id': navigator.userAgent,
            isToken:false
        },
    })
}
